import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgGithubIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 16.186C0 8.644 0 4.872 2.343 2.529S8.458.186 16 .186c7.543 0 11.314 0 13.657 2.343S32 8.644 32 16.186c0 7.543 0 11.314-2.343 13.657S23.543 32.186 16 32.186c-7.542 0-11.314 0-13.657-2.343S0 23.729 0 16.186Z"
      fill="url(#GithubIcon_svg__a)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 4.054c-6.63 0-12 5.37-12 12 0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0 0 28 16.054c0-6.63-5.37-12-12-12Z"
      fill="#fff"
    />
    <defs>
      <linearGradient
        id="GithubIcon_svg__a"
        x1={16}
        y1={4.009}
        x2={16}
        y2={28.725}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#191C1F" />
        <stop offset={1} stopColor="#08080A" />
      </linearGradient>
    </defs>
  </svg>
);
const Memo = memo(SvgGithubIcon);
export default Memo;
